import React, { Component } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import './index.scss'
import { Link } from 'react-router-dom'

export class index extends Component {
  state = {
    items: [require('../../../image/01.png'), require('../../../image/02.png'), require('../../../image/03.png'), require('../../../image/04.png'), require('../../../image/05.png'), require('../../../image/06.png'), require('../../../image/05.png'), require('../../../image/06.png'), require('../../../image/01.png'), require('../../../image/02.png'), require('../../../image/03.png'), require('../../../image/04.png'), require('../../../image/05.png'), require('../../../image/06.png'), require('../../../image/05.png'), require('../../../image/06.png')],
    imgarr: [
      [require('../../../image/company/北京地勘院.jpg'), require('../../../image/company/国家电网.jpg'), require('../../../image/company/徐福记.jpg'), require('../../../image/company/中国海油.jpg'), require('../../../image/company/中国航天.jpg'), require('../../../image/company/中国科学院.jpg'), require('../../../image/company/中国石化.jpg'), require('../../../image/company/中国石油.jpg')]
    ],
    arr: [],
    num: 0
  }
  componentWillMount() {
    const { imgarr } = this.state
    this.setState({ arr: imgarr[0] })
  }
  clickImageLeft = () => {
    const { num, imgarr } = this.state
    this.setState({ arr: imgarr[num - 1], num: num - 1 })
  }
  clickImageright = () => {
    const { num, imgarr } = this.state
    this.setState({ arr: imgarr[num + 1], num: num + 1 })
  }
  render() {
    const { arr, num, imgarr } = this.state
    return (
      <div>
        <div className="mytypeArea Cooperation" style={{ margin: '0 auto' }}>
          <div className="Cooperation-title">
            <div className="Cooperation-title-h1">合作企业</div>
            <div className="Cooperation-title-text">COOPERATIVE PARTNER</div>
          </div>
          <div className="Cooperation-content">
            <div className="Cooperation-content-imgBox">
              <div className="Cooperation-content-imgBox-content">
                {arr.map((i, index) => (
                  <div className="Cooperation-content-imgBox-content-item" key={index}>
                    <img className="Cooperation-content-imgBox-content-item-img" src={i} alt="" />
                  </div>
                ))}
              </div>
            </div>
            <div className="Cooperation-content-operation">
              <div className={`Cooperation-content-operation-left`} onClick={imgarr.length - 1 <= num && imgarr.length - 1 != 0 ? this.clickImageLeft : () => {}}>
                <LeftOutlined style={{ fontSize: ' 1.285714rem' }} />
              </div>
              <div className={`Cooperation-content-operation-right `} onClick={imgarr.length - 1 > num ? this.clickImageright : () => {}}>
                <RightOutlined style={{ fontSize: ' 1.285714rem' }} />
              </div>
            </div>
          </div>
        </div>
        <div className="relation">
          <div className="relation-title">
            立即联系<span style={{ color: '#FFB91A' }}>锐控科技</span>专家团队，为您提供服务!
          </div>
          <div className="relation-content">IoT AI +工业软件赋能数字工业</div>
          <Link to="/contactus.html">
            <div className="relation-button">联系我们</div>
          </Link>
        </div>
      </div>
    )
  }
}

export default index
